import { useDispatch, useSelector } from "react-redux";
import classNames from "classnames";
import { editStatus } from "../../redux/state/status";
import { useTranslation } from "react-i18next";

const AccessLoginRequiredModal = () => {
  let dispatch = useDispatch();
  const {t} = useTranslation();

  const botButtonColor = useSelector(
    (state: { settings: { botButtonColor: string } }) =>
        state.settings.botButtonColor
);


  return (
    <div
      style = {{fontFamily: "'Times New Roman', Times, serif"}}
      className={classNames(
        "fixed w-screen h-screen bg-zinc-800/90 flex justify-center items-center z-20"
      )}
    >
      <div className="w-90pc xs:w-80 small:w-108 medium:w-160 large:w-196 bg-white shadow-lg rounded-xl overflow-hidden">
        <div className="py-10 px-8 small:py-12 small:px-10 content text-center text-sm small:text-base medium:text-lg">
          <h3 className="text-2xl small:text-3xl medium:text-4xl text-black leading-snug">
            {t('vipChat.accessLoginRequired')}
          </h3>
        </div>
      </div>
    </div>
  );
};

AccessLoginRequiredModal.propTypes = {};

export default AccessLoginRequiredModal;
